import { makeStyles, Tooltip, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { formatAddress } from "src/utils";
import { getCurrentNetwork } from "src/configs/connection-config";
import { ExternalLink } from "../icons";

const useStyles = makeStyles(() => ({
  viewOnBSCLink: {
    color: "inherit",
    textDecoration: "none",
    verticalAlign: "middle",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  txHash: {
    cursor: "default",
    fontSize: "inherit",
  },
  tooltip: {
    maxWidth: "none",
  },
}));

function ViewTxOnBSC({ txHash, iconSize, ...rest }) {
  const cls = useStyles();
  const { blockExplorerUrls } = getCurrentNetwork();

  return (
    <Typography {...rest}>
      <Tooltip title={`Transaction Hash: ${txHash}`} placement="top" arrow interactive cls={{ tooltip: cls.tooltip }}>
        <Typography component="span" className={cls.txHash}>
          {formatAddress(txHash)}
        </Typography>
      </Tooltip>
      &nbsp;
      <Tooltip
        title={"View transaction on BSC Explorer"}
        placement="top"
        arrow
        interactive
        cls={{ tooltip: cls.tooltip }}
      >
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={cls.viewOnBSCLink}
          href={`${blockExplorerUrls}/tx/${txHash}`}
        >
          <ExternalLink size={iconSize} />
        </a>
      </Tooltip>
    </Typography>
  );
}

export default ViewTxOnBSC;

ViewTxOnBSC.propTypes = {
  txHash: PropTypes.string.isRequired,
};

ViewTxOnBSC.defaultProps = {
  variant: "body2",
  gutterBottom: true,
  iconSize: 17,
};
